import { serverUrl, socketUrl } from "../services/apiService/baseUrl";

const imgUrlChange = (img,urlChange) => {
  const regex = /^http:\/\/localhost:5000/;
  if (regex.test(img)) {
    const newUrl = img.replace(regex, (urlChange?socketUrl:serverUrl));
    return newUrl;
  } else {
    const newUrl = (urlChange?socketUrl:serverUrl) + img;
    return newUrl;
  }
};
const imgUrlChange2 = (img,urlChange) => {
  const regex = /^http:\/\/localhost:5000/;
  if (regex.test(img)) {
    const newUrl = img.replace(regex, (urlChange?socketUrl:serverUrl));
    return newUrl;
  } else {
    const newUrl = (urlChange?socketUrl:serverUrl) + img;
    return newUrl;
  }
};

export default imgUrlChange
export  {imgUrlChange2};
